import React from "react";
import { Parah, PointsIcon, PointsWrapper } from "../ContentsStyles";

const PP_2 = () => {
  return (
    <>
      <Parah>
        We use your information to operate, provide, develop, and improve the
        Platform, including for the following purposes. You can find more detail
        in “Our Legal Bases and How We Process Your Information”.
      </Parah>
      <PointsWrapper>
        <PointsIcon />
        Provide and administer the Platform, such as enabling you to create,
        share, and consume content and to interact with other users and their
        content.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Personalise and customise your experience on the Platform, such as
        providing your “For You” feed.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Process, facilitate, or fulfil requests of purchases of products, goods,
        and services.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Enforce our Terms, Guidelines, and other policies that apply to you. We
        review User Content and other information to protect the safety and well
        being of our community
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Provide certain interactive features, such as enabling your content to
        be used in other users’ videos, and to suggest your account to other
        users to help connect you with other users.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Provide and improve our advertising services, including to serve ads
        (including personalised ads, where permitted) and to measure and
        understand the effectiveness of the ads and other content.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Maintain and enhance the safety, security, and stability of the Platform
        by identifying and addressing technical or security issues or problems
        (such as technical bugs, spam accounts, and detecting abuse, fraud, and
        illegal activity).
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Review, improve, and develop the Platform, including by monitoring
        interactions and usage across your devices, analysing how people are
        using it, and by training and improving our technology, such as our
        machine learning models and algorithms.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Share your information with third party platforms to provide you with
        features, like content sharing at your request when you integrate your
        Talents Explore account with a third party service.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Promote the Platform or third party services through marketing
        communications, contests, or promotions.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Comply with our legal obligations, or as necessary to perform tasks in
        the public interest, or to protect the vital interests of our users and
        other people.
      </PointsWrapper>
    </>
  );
};

export default PP_2;
